import React, { useState } from "react";
import { Button, Image, Col, Row, Modal, Table } from "react-bootstrap";
import Switch from "react-switch";
import { NavLink } from "react-router-dom";
//import SuperAdminDeleteOffer from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteOffer";
import SuperAdminOfferDelete from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminOfferDelete";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";

const ViewOfferDetailsOfflineAdmin = ({
  onClickshowView,
  onClickCloseView,
  data,
}) => {
  const [showLog, setShowLog] = useState(false);
  const [showMoreDetail, setShowMoreDetail] = useState(false);

  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };

  return (
    <>
      <Modal
        show={onClickshowView}
        onHide={onClickCloseView}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Offer Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          {/* <div className="d-flex">
            <div className="enIMG75">
              <Image
                //src={require("../../../../assets/images/UserManagement/fhr7.png")}
                src={data && data.restaurant_id && data.restaurant_id.logo_url}
                alt="View"
                title="View"
                fluid
                className="w-100 h-100"
              />
            </div>
            <div className="pl-3 row">
              <Col
                lg={10}
                xl={8}
                className="d-flex flex-column justify-content-between"
              >
                <div className="f24-500">
                  {" "}
                  {data &&
                    data.restaurant_id &&
                    data.restaurant_id.restaurant_name}
                  ’s Review
                </div>
                <div className="f14-400">
                  {data &&
                    data.restaurant_id &&
                    data.restaurant_id.restaurant_address}
                </div>
              </Col>
            </div>
          </div>
          <hr /> */}
          <div className="enGrayBorderBox">
            <Row className="px-4">
              <Col lg={7} md={12}>
                <Row>
                  <Col lg={8} md={6} className="py-3">
                    <div className="f12-500 pb-3">My Offers</div>
                    <div className="d-flex align-items-center">
                      <div className="text-center d-flex flex-column align-items-center">
                        <div className="enIMG62">
                          <Image
                            //src={require("../../../../assets/images/UserManagement/offer.png")}
                            src={data && data.photos && data.photos[0]}
                            alt="View"
                            title="View"
                            fluid
                            className="w-100 h-100"
                          />
                        </div>
                        <div className="enPendingLBL mt-2">Offline</div>
                      </div>
                      <div className="pl-3">
                        <div className="f14-500">{data && data.name}</div>
                        <div className="f12-400">Avail Offer on All Items</div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} md={6} className="py-3">
                    <div className="f12-500 pb-3">Start -End Date</div>
                    <div className="f12-500">
                      {" "}
                      {moment(data && data.start_date).format("Do MMM YY")}
                    </div>
                    <div className="f12-500 pl-4 py-1">to</div>
                    <div className="f12-500 text-red">
                      {" "}
                      {moment(data && data.end_date).format("Do MMM YY")}
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={5} md={12}>
                <Row>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">Discount Type</div>
                    <div className="f12-500">Percentage</div>
                  </Col>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">Min Discount</div>
                    <div className="f12-500">10</div>
                  </Col>
                </Row>
              </Col>
              <Col md={12}>
                <hr />
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Status</div>
                <div className="d-flex align-items-center">
                  <div className="f12-400 mr-2">
                    {data && data.active ? "Active" : "Inactive"}
                  </div>
                  <Switch
                    //onChange={toggleFunction}
                    disabled
                    //checked={checked.checked}
                    checked={data && data.active}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={15}
                    width={41}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                  />
                </div>
              </Col>
              {/* <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Primary</div>
                <div className="d-flex align-items-center">
                  <div className="f12-400 mr-2">No</div>
                  <Switch
                    onChange={toggleFunction}
                    checked={data && data.mark_as_primary}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={15}
                    width={41}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                  />
                  <div className="f12-400 ml-2">Yes</div>
                </div>
              </Col> */}
              <Col lg={2} md={4} className="py-3">
                <div className="f12-500 pb-3">Views</div>
                <div className="f14-400"> {data && data.offerViews}</div>
              </Col>
              <Col lg={2} md={4} className="py-3">
                <div className="f12-500 pb-3">Used</div>
                <div className="f14-400">{data && data.offerUsed}</div>
              </Col>
              <Col lg={2} md={4} className="py-3">
                <div className="f12-500 pb-3">Coupon Code</div>
                <div className="f14-400">{data && data.coupon_code}</div>
              </Col>
              <Col md={12}>
                <hr />
              </Col>
              <Col lg={3} md={6} className="py-3 d-flex">
                <NavLink
                  to={`/superadminoffers/edit-admin-offline-offer/${
                    data && data._id
                  }`}
                  className="enIconBtn mr-3"
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/pencil.svg")}
                    alt="Edit"
                    title="Edit"
                    fluid
                  />
                </NavLink>
                <SuperAdminOfferDelete
                  offerId={data && data._id}
                  onClickCloseView={onClickCloseView}
                />
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Coupon Code Usage Limit</div>
                <div className="f14-400">{data && data.offerUsed}</div>
              </Col>
            </Row>
          </div>
          <div className="pt-4 f12-400 opacity5">Offer Name</div>
          <div className="d-flex align-items-center pt-2">
            <div className="f16-500">{data && data.name}</div>
            <div className="enPendingLBL ml-2">Offline</div>
          </div>
          <div className="pt-4 f12-400 opacity5">Description</div>
          <div className="pt-2 f12-400">{data && data.description}</div>
          <hr />
          <Row>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Start Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">
                  {" "}
                  {moment(data && data.start_date).format("DD/MM/YYYY")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Start Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">
                  {" "}
                  {moment(data && data.start_date).format("LT")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">End Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">
                  {" "}
                  {moment(data && data.end_date).format("DD/MM/YYYY")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">End Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">
                  {" "}
                  {moment(data && data.end_date).format("LT")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">Coupon Code</div>
              <div className="f16-700"> {data && data.coupon_code}</div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">Maximum Usage Limit</div>
              <div className="f16-700">100</div>
            </Col>
          </Row>
          <hr />

          <div className="pb-4">
            <div className="pb-2 f12-400 opacity5">View Photo</div>
            <div className="enIMG105">
              {data && data.photos && data.photos[0] ? (
                <Image
                  src={data.photos[0]}
                  alt="offer image"
                  title="offer image"
                  fluid
                  className="w-100 h-100"
                />
              ) : (
                <Image
                  //src={require("../../../../assets/images/UserManagement/offer.png")}
                  alt="offer image"
                  title="offer image"
                  fluid
                  className="w-100 h-100"
                />
              )}
            </div>
            <div className="pt-2 f12-400">
              (You can upload only 1 pic per offer 700 x 420 pixels)
            </div>
          </div>
          <div className="pb-4">
            <div className="pb-2 f12-400 opacity5">View Video</div>
            <div className="enIMG105">
              {/* <Image
                src={require("../../../../assets/images/UserManagement/offer.png")}
                alt="offer"
                title="offer"
                fluid
                className="w-100 h-100"
              /> */}
              {data && data.offerVideo ? (
                <video
                  width="100%"
                  height="100%"
                  controls
                  src={data.offerVideo}
                  type="video/mp4"
                />
              ) : (
                <>
                  {" "}
                  <p> Video Unaivalable</p>{" "}
                </>
              )}
            </div>
            <div className="pt-2 f12-400">
              (You can upload only 1 video per offer)
            </div>
          </div>
          <div className="pb-4">
            <div className="f12-400 opacity5">Terms and Conditions</div>
            <div className="pt-2 f12-400">
              {data && data.terms_and_condition}
            </div>
          </div>
          <hr />
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              View more details{" "}
              <Image
                src={require("../../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? "en180deg" : ""
                }`}
              />
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-4">
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Phone Number</div>
                  <div className="f14-400">+91-xxxxxx7890</div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Offer ID</div>
                  <div className="f14-400 text-break">#{data && data._id}</div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Start Date / Time</div>
                  <div className="f14-400">
                    {" "}
                    {moment(data && data.start_date).format("Do MMMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {" "}
                    {moment(data && data.start_date).format("LT")}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">End Date / Time</div>
                  <div className="f14-400">
                    {" "}
                    {moment(data && data.end_date).format("Do MMMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {" "}
                    {moment(data && data.end_date).format("LT")}
                  </div>
                </Col>
                <Col md={12}>
                  <hr />
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Changed Date / Time</div>
                  <div className="f14-400">
                    {" "}
                    {moment(data && data.updatedAt).format("Do MMMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {" "}
                    {moment(data && data.updatedAt).format("LT")}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Created Date / Time</div>
                  <div className="f14-400">
                    {moment(data && data.createdAt).format("Do MMMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {moment(data && data.createdAt).format("LT")}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Pont of Entry</div>
                  <div className="f14-400">Menually Added</div>
                </Col>
                {/* <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Maximum Usage Limit</div>
                  <div className="f14-400">100</div>
                </Col> */}
              </Row>
            </div>
          )}
          <hr />
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{" "}
            <Image
              src={require("../../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? "en180deg" : ""}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <thead>
                  <tr>
                    <th className="">
                      <div className="f12-500">Date</div>
                    </th>
                    <th>
                      <div className="f12-500">Operation</div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {((data && data.auditLogs) || []).map((data, index) => (
                    <tr key={index}>
                      <td>
                        <div className="f12-500">
                          {moment(data.timestamp).format("Do MMMM YYYY")}
                        </div>
                        <div className="f12-500">
                          {moment(data.timestamp).format("hh:mm A")}
                        </div>
                      </td>
                      <td>
                        <div className="f12-500">{data.message}</div>
                      </td>
                      <td>
                        <div className="f12-500">
                          {data.initiator === "VENDOR" ? "You" : data.initiator}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

ViewOfferDetailsOfflineAdmin.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(ViewOfferDetailsOfflineAdmin);
